import { connect } from "react-redux";
import { reduxForm, SubmissionError } from "redux-form/immutable";

import { Dispatch, State } from "common/types/redux";

import firebaseErrorTranslator, {
  ErrorMessage
} from "services/firebase/auth/errorTranslator";

import {
  getPasswordResetEmail,
  getResubmitCodeError,
  getResubmitCodePending,
  getResubmitCodeSuccess
} from "seneca-common/features/user/state";
import { validatePasswordBasic } from "seneca-common/utils/functions/validation/password";
import { validateEmailLoosely } from "seneca-common/utils/functions/validationFunctions";

import {
  resendPasswordResetEmail,
  signInWithEmailAndPassword
} from "features/user";

import ResetPasswordSignInForm from "../components/ResetPasswordSignInForm";

const formName = "RESET_PASSWORD_SIGN_IN";

type Props = {
  onSignInSuccess: () => void;
  pageNumber?: number;
  totalNumberOfPages?: number;
};

function validate(valuesIn: any) {
  const { email, password } = valuesIn.toJS();
  return {
    email: validateEmailLoosely(email),
    password: validatePasswordBasic(password)
  };
}

const WrappedResetPasswordSignInForm = reduxForm({
  form: formName,
  // @ts-ignore
  validate,
  // @ts-ignore
  onSubmit: async (
    formValues: Map<string, string>,
    dispatch: Dispatch,
    { onSignInSuccess }: Props
  ) => {
    try {
      await dispatch(
        signInWithEmailAndPassword(
          formValues.get("email")!,
          formValues.get("password")!
        )
      );
      onSignInSuccess && onSignInSuccess();
    } catch (error: any) {
      throw new SubmissionError<{}, ErrorMessage>({
        _error: firebaseErrorTranslator(error)
      });
    }
  }
  // @ts-ignore
})(ResetPasswordSignInForm);

function mapStateToProps(state: State, ownProps: Props) {
  const email = getPasswordResetEmail(state) as any;
  return {
    initialValues: {
      email
    },
    resendCodePending: getResubmitCodePending(state, email),
    resendCodeSuccess: getResubmitCodeSuccess(state, email),
    resendCodeError: getResubmitCodeError(state, email!),
    ...ownProps
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    sendEmailAgain: async () => dispatch(resendPasswordResetEmail())
  };
}

export default connect(
  mapStateToProps,
  // @ts-ignore
  mapDispatchToProps
)(WrappedResetPasswordSignInForm);
